(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MuseDOM", [], factory);
	else if(typeof exports === 'object')
		exports["MuseDOM"] = factory();
	else
		root["MuseDOM"] = factory();
})(window, function() {
return 